import { useState } from 'react';

export default function FloatingLabelInput({
  label,
  value,
  onChange,
  type = 'text',
  error,
  required,
  disabled,
  suffix,
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const active = focused || (value != null && value !== '');

  const borderColor = error ? '#ef4444' : focused ? '#6b7280' : '#d1d5db';
  const labelColor = error ? '#ef4444' : focused ? '#374151' : '#9ca3af';

  return (
    <div style={{ position: 'relative' }}>
      <input
        type={type}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        disabled={disabled}
        required={!!required}
        style={{
          width: '100%',
          border: `1px solid ${borderColor}`,
          padding: '20px 12px 6px 12px',
          paddingRight: suffix ? '40px' : '12px',
          fontSize: '14px',
          outline: 'none',
          background: disabled ? '#f9fafb' : 'white',
          boxSizing: 'border-box',
          transition: 'border-color 0.15s ease',
        }}
        {...props}
      />
      <label
        style={{
          position: 'absolute',
          left: '12px',
          top: active ? '0px' : '50%',
          transform: 'translateY(-50%)',
          fontSize: active ? '11px' : '14px',
          color: labelColor,
          background: 'white',
          padding: '0 3px',
          transition: 'all 0.15s ease',
          pointerEvents: 'none',
          lineHeight: '1',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
        {required && (
          <span style={{ color: '#ef4444', marginLeft: '2px' }}>*</span>
        )}
      </label>
      {suffix && (
        <div
          style={{
            position: 'absolute',
            right: '8px',
            top: 'calc(50% + 7px)',
            transform: 'translateY(-50%)',
          }}
        >
          {suffix}
        </div>
      )}
    </div>
  );
}
